import React from 'react';
import SearchableSelect from '../SearchableSelect/SearchableSelect';
import { IGrowersAreaItem } from '../../../modules/API/Defaults/models/growersArea';
import MapPinIcon from '../../icons/IconLib/MapPinIcon';

interface Props {
    fields: IGrowersAreaItem[];
    value: IGrowersAreaItem | null;
    onSelect: (f: IGrowersAreaItem | null) => void;
    placeholder?: string;
    disabled?: boolean;
    readOnly?: boolean;
    className?: string;
}

/**
 * Picks a "grower field" (Lot / חלקה). Caller is responsible for filtering
 * the list by the currently selected grower (typically via useDataFetcher
 * keyed on GrowerID) — this component just renders the already-filtered list.
 */
const GrowerFieldSelector: React.FC<Props> = ({
    fields,
    value,
    onSelect,
    placeholder = 'בחר חלקה',
    disabled,
    readOnly,
    className,
}) => (
    <SearchableSelect<IGrowersAreaItem>
        items={fields}
        value={value}
        onSelect={onSelect}
        getKey={(f) => f.LotID}
        getLabel={(f) => (f.LotReference ?? '').trim()}
        placeholder={placeholder}
        disabled={disabled}
        readOnly={readOnly}
        leadingIcon={<MapPinIcon />}
        className={className}
        emptyLabel='אין חלקות מתאימות'
    />
);

export default GrowerFieldSelector;
